import React, { useEffect, useState } from 'react';
import { Slider } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n/index';
import type { IBackgroundLayerProps, ILayerProps } from '@/version-types';
import './crop-background-toolbar.less';
import { useFramework } from '@/framework';
import { adjustCropLayer } from '@/utils/crop-img-kit';
import { type CropBackground } from '../crop-background';
import { CROP_BACKGROUND_EVENTS } from '../event-name';

const CropBackgroundToolbar: React.FC = () => {
    const framework = useFramework();
    const cropBackground = framework.service.registration.getInstance<CropBackground>('CropBackground');
    const [layer, setLayer] = useState<ILayerProps | null>(cropBackground.getLatestLayer());
    // const [opacity, setOpacity] = useState(1);
    const { $t } = useLocaleStore();
    const [isChange, setIsChange] = useState(false);

    const setScaleTip = (value: number = 100) => {
        let tip = value + '%';
        if (value >= 300) {
            tip = $t((v) => v.corpImage.tip);
        }
        return tip;
    };

    // useEffect(() => {
    //     setTimeout(() => {
    //         setOpacity(1);
    //     }, 10);
    // }, []);

    useEffect(() => {
        const handler = framework.service.events.on(CROP_BACKGROUND_EVENTS.SET_LATEST_LAYER, (layer: ILayerProps) => {
            setLayer(layer);
            setIsChange(true);
        });
        return () => {
            framework.service.events.off(handler);
        };
    }, []);

    if (!layer) return null;

    const { imageTransform } = layer.data as IBackgroundLayerProps;
    const { scale } = imageTransform ?? {};
    const setScale = (scale: number, isEnd?: boolean) => {
        imageTransform.scale = scale > 3 ? 3 : scale < 1 ? 1 : scale;
        if (isEnd) {
            adjustCropLayer(layer);
        }
        cropBackground.setLatestLayer({ ...layer });
    };

    return (
        <div
            className="crop-background-toolbar"
            style={{
                top: 10,
                transform: `translate(-50%, 0)`,
                // opacity,
            }}
        >
            <div className="crop-background-toolbar__left">
                <div className="crop-background-toolbar__title">{$t((v) => v.corpImage.scale)}</div>
                <Slider
                    className="crop-background-toolbar__slider"
                    defaultValue={scale * 100}
                    value={scale * 100}
                    min={100}
                    max={300}
                    tooltip={{ formatter: setScaleTip }}
                    onChange={(e) => setScale(e / 100)}
                    onAfterChange={(e) => setScale(e / 100, true)}
                />
            </div>
            <ul className="crop-background-toolbar__right">
                <li className={!isChange ? 'disable' : ''} onClick={() => cropBackground.reset()}>
                    <span>{$t((v) => v.corpImage.reset)}</span>
                </li>
                <li onClick={() => cropBackground.cancel()}>
                    <IconFont name="CrossBlack" fontSize={16}></IconFont>
                </li>
                <li className="active" onClick={() => cropBackground.confirm()}>
                    <IconFont name="CheckBlack" fontSize={16}></IconFont>
                </li>
            </ul>
        </div>
    );
};

export default CropBackgroundToolbar;
